export function loggedInStatus(state = 'pending', action){
    switch(action.type){
        case 'SET_LOGGED_IN_STATUS':
            return action.status;
        default:
            return state;
    }
}

export function user(state = {}, action){
    switch(action.type){
        case 'SET_LOGGED_IN_USER':
            return action.user;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/reducers.js